export const formatUserScopes = (formValues) => {
  const keys = Object.keys(formValues)
  const trueKeys = keys.filter((key) => formValues[key] === true)
  return trueKeys.join(',')
}
